import { ColorPicker } from '@/components/ColorPicker';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import PaintRoller from '@/images/PaintRoller.svg';
import styled from '@emotion/styled';
import { useController, useFormContext } from 'react-hook-form';

export const allowedColors = ['#7559FF', '#F08B55', '#A1D070', '#4D87F5', '#AF48EB'];

const ColorContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
`;

const Color = styled.div<{ color: string }>`
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-color: ${({ color }) => color};
    cursor: pointer;
`;

const StyledMaskedIcon = styled(MaskedIcon)<{ color: string }>`
    background-color: ${({ color, theme }) => (color.includes('000') ? 'white' : theme.colors.black[900])};
`;

export const ColorsField = () => {
    const { control } = useFormContext();

    const { field } = useController({
        name: 'cta_background_color',
        control,
    });

    const { value = '#FFF', onChange } = field;

    return (
        <ColorContainer id="campaign-cta-background-color">
            <ColorPicker value={value} onChange={onChange} size="32px">
                <StyledMaskedIcon src={PaintRoller} color={value} size="21px" />
            </ColorPicker>

            {allowedColors.map(color => (
                <Color
                    key={color}
                    color={color}
                    onClick={() => onChange(color)}
                    style={{
                        border: value === color ? '2px solid black' : 'none',
                    }}
                />
            ))}
        </ColorContainer>
    );
};
